import { Paper, styled } from '@mui/material';

import { DropZoneFlags } from './ConversationInput.types';

const preventPropForward: Record<string, boolean> = {
  isDragActive: true,
  isDragAccept: true,
  isDragReject: true,
};

export const ConversationInputRoot = styled(Paper, {
  shouldForwardProp: (prop) => !preventPropForward[String(prop)],
})<DropZoneFlags>(({ theme, isDragReject }) => ({
  width: '100%',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  borderColor: isDragReject ? theme.palette.error.main : theme.palette.divider,
  borderWidth: '1px',
  borderStyle: 'solid',
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));
